import type { ReactNode } from 'react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { cn } from '@/lib/utils'

type KnowledgeDialogProps = {
  open: boolean
  title: string
  onClose: () => void
  children: ReactNode
}

export function KnowledgeDialog({
  open,
  title,
  onClose,
  children,
}: KnowledgeDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(v) => {
        if (!v) onClose()
      }}
    >
      <DialogContent
        className={cn(
          'w-[min(1200px,96vw)] max-w-none p-0 lg:w-[min(1400px,96vw)]',
          'h-[82vh] overflow-hidden',
          // ✅ 关键：建立高度体系
          'flex min-h-0 flex-col gap-0'
        )}
      >
        <DialogHeader className='border-border flex shrink-0 flex-row items-center justify-between gap-4 border-b px-6 py-4'>
          <DialogTitle className='text-base font-medium'>{title}</DialogTitle>
        </DialogHeader>

        {/* ✅ 关键：这里改成 overflow-auto，保证至少整体能滚 */}
        <div className='min-h-0 flex-1 overflow-auto px-6 py-5'>{children}</div>
      </DialogContent>
    </Dialog>
  )
}
